import { get } from 'lodash/fp';

export const getSidePanelData = get('ui.sidePanel.data');

export const isSidePanelOpen = get('ui.sidePanel.open');
